import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import moment from 'moment';

export class DormTrans extends Component {
    static displayName = DormTrans.name;
    
    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            tableData: [],
            newDate: "",
            buildings: ["5", "7"], //This default value should be overwritten as soon as this.getBuildings() executes, the only reason we're putting 5 and 7 here is because until that happens
                                   //this.state.buildings.map() will try to map through an empty array without these and when you try to map through an empty array Javascript strenuously objects
            enterPCID: "",
            studentName: "",
            ip: "",
            rooms: ["Please select a building to get the rooms"], //This has a default value provided in here because until the user selects a building there won't be any rooms. We provide
                                                                  //this default value to tell the user they need to decide which building to pick a room from before we can let them pick
                                                                  //one of the rooms in it.
                                                                  //We do that because if we listed every single room available to students it would be longer than the King James Bible.
            globalLevel: "",
            browser: `${browserName}${browserVersion}`,
            submittedFlag: [],
            permissionFlag: true,
            IP: "",
            changeFlag: false
        };
        this.getData();
        //This particular call might be able to go into componentDidMount() if we're willing to put a loading circle in the table's location while the call is waiting
        
    }

    async getData() { //This is the beginning of a chain of functions within functions. This is done to make sure they're done in order because they need the previous one's data to work.
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getImportantThings();
    }

    async getImportantThings() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //This is the same fetch('user') as exists in NavMenu.js as this.populateDropdown(), with some extra things added to it
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            enterPCID: data.username,
            globalLevel: data.level,
            returnable: data
        })
        //this.recordComingHere();
        this.testPermission();
        //var dept = this.state.returnable.level //Here we begin the extra things. This is meant to determine whether or not the chosen level is allowed to see this page, and if it isn't
        //it sets a state flag to false to have render() redirect to AccessForbidden.js. 
        //dept = dept.substring(0, dept.indexOf('-') - 1); //The current level here is saved as a full string of department and rank, so the rank part needs to be trimmed off in order to compare it
    }

    componentDidMount() {
         //We're able to get away with putting this into componentDidMount() because this is populating the select option for the buildings and nobody's enough of 
                             //a quickdraw to click on that before this populates
       
    }
    //todo: reorder the functions' placement here so it makes sense with respect to the page lifecycle
    //async recordComingHere() { //This logging will be the same in every page-type component with the sole exception of the pagePK string being specific to the page
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //     let toSend = {
    //         pagePK: "8",
    //         department: this.state.returnable.level,
    //         userPCID: this.state.returnable.pcid,
    //         ip: this.state.IP,
    //         browser: this.state.browser,
    //         userID: this.state.returnable.username
    //    }
    //     const response = await fetch('logging', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //         body: JSON.stringify(toSend)
    //     });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "8"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getTableData();
        this.getBuildings();
    }

    async nameLookup(e) { //This function will fire every time the user types a character into the PCID field or deletes a character
        if (e.target.value.length == 10) { //You may have noticed the fact that it fires on textbox change means there will be a lot of times this function executes. That's what this 
                                           //if statement is for. If the new value isn't the right length to be a proper PCID, it's obviously not a proper PCID and it can be ignored.
                                           //This does allow for invalid PCIDs to be given to the controller (like 'V001324953'), but these will produce an error code which will be 
                                           //displayed to the user. The user would probably like to know that the student they're trying to give access to doesn't actually exist.
                                           //My first instinct when adding this filter was to use a regex to check whether it's an actual PCID, but React seems to dislike regex
                                           //so that filtering exists in the controller now and we'll just deal with bogus controller fetches
            let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
            let toSend = {
                stuPCID: e.target.value,
                userLevel: this.state.returnable.level
            }
            const response = await fetch('StuLookupDormTrans', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            localStorage.setItem("lastFetch", moment());
            this.setState({
                studentName: data.stuName
            });
        } else {
            this.setState({
                studentName: ""//When a PCID was in the textbox and then deleted, without this the previous retrieved value will linger. This replaces it with a blank string.
            })
        }
    }

    async getTableData() {//this.state.tableData needs to store all the information that is going to be provided in the table. The fetch is fairly simple, using it in render() is not
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('trans', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data
        });

    }

    async getBuildings() { //This is only going to show buildings that have student dorms in them
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('building', { method: 'POST', headers: { 'Content-Type': 'application/json','Authorization': bearerVAR }, body: JSON.stringify(toSend) });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            buildings: data.id 
        }); 
    }

    async addNew(e) {//When the submit new student button is clicked, this method fires to add that information as a new student dorm transition
        e.preventDefault(); //To be honest, I'm not entirely sure what this does, but without it the function breaks the page.
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const dataInput = new FormData(e.target);//We can get away with using e.target.value when the trigger is on a single field, but this button reads 
                                                 //all of the entries. While using 'e.target.stuPCID' and such might work, it's better to have a holder variable 
                                                 //here to make sure everything's ready in one place
        let toSend = {
            studentPCID: dataInput.get('stuPCID'),
            building: dataInput.get('buildingID'),
            room: dataInput.get('roomID'),
            expDate: dataInput.get('expDate'), 
            recorderName: this.state.enterPCID, //todo: investigate whether this is necessary. Recorder name should be generated from session data in the controller
            flag: "DORM", //AddTransitionController is used by both this component and HonorsKeycardAccess.js, so this flag lets both it and the single table it inserts 
                          //into which form this JSON is coming from
            activeLevel: this.state.globalLevel
        };
        const response = await fetch('addtransition', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({ //Most of the time, posts don't actually do anything with the returned information. However, with these we're using the returned boolean to decide whether to let 
                        //the user know the write succeeded
            submittedFlag: data
        }, () => { this.getTableData(); });//Now we refresh the table so the user doesn't have to hit refresh

        setTimeout(() => {//This will wait four seconds and then remove the Success indicator
            this.setState({
                submittedFlag: false
            })
        }, 4000)
         
    }

    async changeExpDate(pcid, room, building, pk, e) { //If a user wants to change the expiration date of a student's dorm transition access, this is what does it. It's fired on the Submit
                                                        //action. This also serves as the delete function, as setting the expiry date to the past will effectively revoke the student's access
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const dataInput = new FormData(e.target);      
        //if (this.state.newDate != "" && this.state.newDate.length >= 8 && this.state.newDate.length <= 10) {
                        //I wanted to do the same pre-detection of whether this is a valid entry as I do in this.nameLookup(), but the entries for this field have a varied length.
                        //A date on January 2nd has a length of 8 characters (1/2/20XX), but December 17th has ten (12/17/20XX) in the format that is displayed to the user and therefore
                        //in the format that the user will input. Therefore, this range is necessary for this pre-detection. This means wack stuff will be able to make it through
                        //like '12/17/20', but there's a finer layer of detection in the controller and this method doesn't even fire unless the user is done typing anyway
            let toSend = {
                recordPK: pk, //Including the record PK in the body makes the rest of this pretty useless, however it's being passed and controlled for in the procedure just to be thorough
                targetPCID: pcid,
                updateDate: dataInput.get('expdate'),
                targetRoom: room,
                targetBuilding: building,
                activeLevel: this.state.globalLevel
            }
            const response = await fetch('updateTrans', { //Like AddTransitionController.cs, UpdateTransController.cs is used by both this and HonorsKeycardAccess.js for changing existing
                                                          //data. However, this controller doesn't need to know whether it's updating a dorm value or an honors value
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
            this.setState({
                submittedFlag: data//Like in this.addNew(), we are using the returned boolean to decide whether we should tell the user the requested operation was successful
            }, () => { this.getTableData(); })//Now we refresh the table so the user doesn't have to hit refresh. 
            setTimeout(() => {//This will wait four seconds and then remove the Success indicator
                this.setState({
                    submittedFlag: false
                })
            }, 4000)
             
        //}
    }

    setStagedDate(e) { //This is a depreciated attempt at implementing what is now this.changeExpDate(). It can probably be safely removed.
        if (e.target.value.length >= 8 && e.target.value.length <= 10) { 
            this.setState({
                newDate: e.target.value
            });
        }
    }

    async getRooms(e) { //This will only fire when a building has been selected and will fire again when a different building has been selected
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            building: e.target.value,
            userLevel: this.state.returnable.level
        }
        const response = await fetch('room', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({ 
            rooms: data.roomList
        });
    } 

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className='d-flex' onSubmit={this.addNew.bind(this)}>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Student PCID</Label>
                                    <Input onChange={this.nameLookup.bind(this)} type="text" name="stuPCID" id="stuPCID" bsSize="sm" />
                                    <FormText>{this.state.studentName}</FormText>
                                </FormGroup>
                                <br />
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Current Building</Label>
                                    <Input type="select" name="buildingID" id="buildingID" bsSize="sm" onChange={this.getRooms.bind(this)}>
                                        <option>Please select a building</option>
                                        {this.state.buildings.map(size => (
                                            <option>{size}</option>))}
                                    </Input>
                                </FormGroup>
                                <br />
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Current Room</Label>
                                    <Input type="select" name="roomID" id="roomID" bsSize="sm">
                                        {this.state.rooms.map(size => (
                                            <option>{size}</option>))}
                                    </Input>
                                </FormGroup>
                                <br />
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label className="mr-sm-2">Expires on:</Label>
                                    <Input type="date" name="expDate" id="expDate" bsSize="sm" />
                                </FormGroup>
                                <br />
                                <Button type="submit" color="success" outline>Submit</Button>&emsp;<div style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.submittedFlag == true ? 'visible' : 'hidden' }} /></div>
                            </Form>
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>PCID</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Nickname</th>
                                        <th>Building</th>
                                        <th>Room</th>
                                        <th>Expiration Date</th>
                                        <th>Entered On</th>
                                        <th>Entered By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.tableData.map(size => (
                                        <tr>
                                            <th>{size.pk}</th>
                                            <td>{size.pcid}</td>
                                            <td>{size.firsT_NAME}</td> {/*No, I don't know why the capitalization is all weird here. I didn't write it like this but JSON has other plans for us.*/}
                                            <td>{size.lasT_NAME}</td>
                                            <td>{size.nickname}</td>
                                            <td>{size.building}</td>
                                            <td>{size.room}</td>
                                            <td><Form onSubmit={(e) => this.changeExpDate(size.pcid, size.room, size.building, size.pk, e)} ><Input
                                                type="date"
                                                name="expdate"
                                                id="expdate"
                                                defaultValue={size.expiration_Date}
                                                key={size.expiration_Date}
                                            />   <Button type="submit" color="success" outline>Update</Button><div style={{ visibility: this.state.changeFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.changeFlag == true ? 'visible' : 'hidden' }} /></div></Form></td>
                                            <td>{size.enteredOn}</td>
                                            <td>{size.enteredBy}</td>
                                        </tr>
                                        ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </UserContext.Consumer>
            );/*
             * todo:  Fix table expiration date form to use type="date"
             * Mapping through tableData proved to be a surprise because each item it maps through is a whole record with columns that need to be individually identified; you can't just say
             * {size} without specifying which value in the current {size} needs to be read. It shoudn't have taken me as long to figure out in hindsight as it did, but it's working now.
             * That said, the expiration_Date field was every bit the challenge I expected it to be and could still use some work. It's a textbox because no matter what I tried
             * making it a date entry meant it would refuse to actually display the placeholder in the entry area instead of its default 'mm/dd/yyyy' even when I changed the datatype
             * of its provided value in {size} to a date in the controller itself. This way, the placeholder value that is retrieved by this.getTableData() at least shows the eixsting
             * expiration date as light gray values in the textbox when you're not typing in it. I know the functionality I'm looking for exists, and implementing it is on the list of things
             * to do.
             * */
    }
}